export const AREAS = [
  "Médica",
  "Enfermería",
  "Cocina",
  "Intendencia",
  "Atención a clientes",
  "Farmacia",
  "Administrativa",
] as const;

export const TURNOS = ["Matutino", "Vespertino", "Nocturno", "Mixto", "Fin de semana"] as const;

export const JORNADAS = [
  "Tiempo completo",
  "Medio tiempo",
  "Rol de turnos",
  "Guardias",
  "Por proyecto",
] as const;

export const ESCOLARIDADES = [
  "Secundaria",
  "Bachillerato",
  "Carrera técnica",
  "Licenciatura",
  "Especialidad",
  "Maestría",
  "Doctorado",
] as const;

export const ESTATUS_POSICION = ["borrador", "publicada", "pausada", "cerrada"] as const;
export type EstatusPosicion = (typeof ESTATUS_POSICION)[number];

export const ETIQUETA_ESTATUS_POSICION: Record<EstatusPosicion, string> = {
  borrador: "Borrador",
  publicada: "Publicada",
  pausada: "Pausada",
  cerrada: "Cerrada",
};

export const ESTATUS_POSTULACION = [
  "nueva",
  "en_revision",
  "entrevista",
  "evaluacion",
  "seleccionado",
  "reserva",
  "no_seleccionado",
  "retirada",
] as const;
export type EstatusPostulacion = (typeof ESTATUS_POSTULACION)[number];

export const ETIQUETA_ESTATUS_POSTULACION: Record<EstatusPostulacion, string> = {
  nueva: "Nueva",
  en_revision: "En revisión",
  entrevista: "Entrevista",
  evaluacion: "Evaluación",
  seleccionado: "Seleccionado",
  reserva: "Reserva",
  no_seleccionado: "No seleccionado",
  retirada: "Postulación retirada",
};

export const TIPOS_DOCUMENTO = [
  { clave: "curriculum", etiqueta: "Currículum", obligatorio: true },
  { clave: "identificacion", etiqueta: "Identificación", obligatorio: false },
  { clave: "comprobante_estudios", etiqueta: "Comprobante de estudios", obligatorio: false },
  { clave: "cedula", etiqueta: "Cédula profesional (si aplica)", obligatorio: false },
  { clave: "certificaciones", etiqueta: "Certificaciones (si aplica)", obligatorio: false },
  { clave: "otros", etiqueta: "Otros documentos relevantes", obligatorio: false },
] as const;

export const PREGUNTAS_POSTULACION = [
  "¿Por qué consideras que deberíamos elegirte para formar parte de MEDAM en esta posición?",
  "MEDAM tendrá procesos, responsabilidades y estándares claramente definidos. ¿Qué puedes aportar para ayudar a construir esta forma de trabajar?",
  "Cuéntanos una situación concreta en la que hayas hecho más de lo esperado para ayudar a un paciente, usuario o compañero.",
  "¿Qué aspecto profesional consideras que necesitas fortalecer para desempeñarte mejor en esta nueva etapa?",
  "Si fueras seleccionado, ¿qué compromiso personal asumirías durante tus primeros 90 días en MEDAM?",
  "¿Por qué quieres formar parte de MEDAM?",
] as const;

export const VALORES_MEDAM = [
  {
    titulo: "Calidad",
    descripcion:
      "Diagnósticos y tratamientos con precisión, eficacia y apego a los más altos estándares clínicos.",
  },
  {
    titulo: "Seguridad",
    descripcion:
      "Entornos seguros para pacientes, personal y visitantes en cada nivel de atención.",
  },
  {
    titulo: "Confianza",
    descripcion:
      "Relaciones sólidas y duraderas a través de resultados, transparencia y trato digno.",
  },
  {
    titulo: "Empatía y respeto",
    descripcion:
      "Escuchamos y acompañamos a cada persona con sensibilidad y respeto por su dignidad.",
  },
  {
    titulo: "Ética",
    descripcion: "Actuamos con integridad, responsabilidad y profesionalismo en cada decisión.",
  },
  {
    titulo: "Innovación",
    descripcion:
      "Tecnología y soluciones digitales para anticiparnos a las necesidades médicas de la comunidad.",
  },
  {
    titulo: "Compromiso social",
    descripcion:
      "Trabajamos por el bienestar colectivo y el desarrollo regional con visión incluyente y solidaria.",
  },
] as const;

export const MISION_MEDAM =
  "Brindar atención médica integral, oportuna y de alta especialidad con calidad humana, tecnología avanzada y un enfoque centrado en el paciente, elevando el bienestar de la comunidad de Texcoco y la región.";

export const VISION_MEDAM =
  "Ser el centro médico de referencia en el Estado de México por su excelencia clínica, innovación en servicios de salud y compromiso social, contribuyendo a una sociedad más saludable, equitativa y con acceso digno a la atención médica.";


export const LEYENDA_CONVOCATORIA =
  "La participación en esta convocatoria representa una manifestación de interés y no constituye una oferta, promesa o garantía de contratación. Todas las postulaciones serán evaluadas conforme a los requisitos y al proceso de selección de cada posición.";

export function formatearFecha(valor: string | null | undefined): string {
  if (!valor) return "Sin fecha límite";
  const fecha = new Date(`${valor.slice(0, 10)}T12:00:00`);
  return fecha.toLocaleDateString("es-MX", { day: "2-digit", month: "long", year: "numeric" });
}

export function formatearFechaHora(valor: string | null | undefined): string {
  if (!valor) return "—";
  return new Date(valor).toLocaleString("es-MX", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
